module.exports = __webpack_public_path__ + "img/cate-2-147534.png";